import React from 'react';
import { Box, CssBaseline } from '@mui/material';
import Sidebar, { drawerWidth } from '../Sidebar/Sidebar.tsx';
import { isAuthenticated } from '../../contexts/AuthContext.tsx';
import { topBarHeights } from './layoutConstants.ts';

interface Props {
  children: React.ReactNode;
}

const SidebarLayout: React.FC<Props> = ({ children }) => {
  const auth = isAuthenticated();

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: 'background.default' }}>
      <CssBaseline />
      {auth ? <Sidebar /> : null}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          ml: auth ? `${drawerWidth}px` : 0,
          minHeight: '100vh',
          px: { xs: 2, md: 3 },
          pt: { xs: 1, md: 2 },
          pb: 4,
        }}
      >
        <Box sx={{ height: topBarHeights, flexShrink: 0 }} />
        {children}
      </Box>
    </Box>
  );
};

export default SidebarLayout;
